<!-- Centered modal (first non-minimized job). -->
<div *ngIf="modalJob$ | async as job" class="pc-deletion-backdrop">
  <div
    class="pc-deletion-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="job.label"
  >
    <span class="pc-deletion-modal__icon material-icons" aria-hidden="true"
      >warning_amber</span
    >
    <h2 class="pc-deletion-modal__title">{{ titleFor(job) }}</h2>
    <p class="pc-deletion-modal__subtitle">{{ subtitleFor(job) }}</p>

    <app-progress-bar
      variant="modal"
      [percent]="job.percent"
      [label]="phaseFor(job)"
    ></app-progress-bar>

    <div class="pc-deletion-modal__actions">
      <button
        type="button"
        class="pc-deletion-modal__bg-btn"
        (click)="runInBackground(job.jobId)"
      >
        {{ runInBackgroundLabel }}
      </button>
    </div>
  </div>
</div>

<!-- Collapsed bottom-right toasts (minimized jobs). Draggable; NOT closeable —
     a background deletion can't be cancelled, so there is no dismiss control. -->
<div class="pc-deletion-toast-stack">
  <div
    *ngFor="let job of toastJobs$ | async; trackBy: trackByJobId"
    class="pc-deletion-toast"
    cdkDrag
    cdkDragBoundary="body"
    role="status"
    aria-live="polite"
    [attr.aria-label]="job.label"
  >
    <div class="pc-deletion-toast__header" cdkDragHandle>
      <span class="pc-deletion-toast__spinner material-icons" aria-hidden="true"
        >autorenew</span
      >
      <span class="pc-deletion-toast__label">{{ job.label }}</span>
    </div>

    <app-progress-bar
      variant="toast"
      [percent]="job.percent"
    ></app-progress-bar>

    <div class="pc-deletion-toast__hint">
      <span
        class="pc-deletion-toast__hint-icon material-icons"
        aria-hidden="true"
        >visibility</span
      >
      <span>{{ toastHint }}</span>
    </div>
  </div>
</div>
